module.exports = __webpack_public_path__ + "img/phone.e92fc0d4.svg";